exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Ovverride rc-progressbar css to fix issue with length of bar */\r\n.rc-progress-line-path {\r\n  stroke-dashoffset: 4px !important;\r\n}\r\n\r\n/* Popup content typography\r\n */\r\n.leazard-info div p {\r\n  margin-bottom: 1em;\r\n}\r\n\r\n/* Keep host site h1 styles (e.g. Tailwind text-5xl) from leaking into popups */\r\n.leazard-info h1 {\r\n  font-size: 3em;\r\n  line-height: 1.2;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* Size drop zone text like the form's paragraphs so it scales with them */\r\n.lz-files .lz-files--drop-area p {\r\n  font-size: 1.3em;\r\n}\r\n", ""]);

// exports
